module.exports = __webpack_public_path__ + "img/introduction_bg.8d1225c1.png";